import { render } from "./Search.vue?vue&type=template&id=48befafa&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=48befafa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-48befafa"

export default script